<template>
  <div class="registration">
    <template v-if="$route.meta.registerWizzard">
      <div class="registrationPrompt registrationPrompt--Register">
        <div class="registrationTop">
          <p class="registrationPrompt__Route registrationPrompt__Route--Register">
            {{ $store.getters.getStringTranslation('alreadyHaveAcc') }}
            <router-link :to="{ name: 'Login' }">{{ $store.getters.getStringTranslation('signIn') }}</router-link>
          </p>
        </div>
        <router-view></router-view>
      </div>
    </template>
    <template v-else>
      <header class="registrationHeader" :style="image">
        <h1 class="registrationHeader__Logo">
          <img src="@/assets/images/logo-dark.svg" alt="" />
        </h1>
      </header>

      <div class="registrationPrompt">
        <transition name="page">
          <router-view></router-view>
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Registration',
  props: ['lang'],
  computed: {
    image() {
      return `background-image: url(https://pop-umbrella.s3.amazonaws.com/static/images/login_${
        Math.floor(Math.random() * 3) + 1
      }.jpg)`
    },
  },
  mounted() {
    this.$store.commit('setOrg', {})
  },
}
</script>
